require.register("ffss/component/row/competition/List", function(exports, require, module){
  $0
  
});

